import React, { useEffect } from "react";

import "./PowerSearch.css";
import Loading from "../../components/Loading/Loading";
import filter from "../../assets/filter.png";
import enlarge from "../../assets/enlarge.png";
import arrowDown from "../../assets/arrow-down.png";
import back from "../../assets/back.png";
import backwhite from "../../assets/backwhite.png";
import close from "../../assets/close.png";
import userprofile from "../../assets/userprofile.png";
import {
  GoogleMap,
  HeatmapLayer,
  useJsApiLoader,
} from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, set } from "date-fns";
import axios from "axios";
import base64 from "base-64";
import { Table } from "../../components/Table/Table";
import Input from "../../components/Input/Input";
import Dropdown from "../../components/Dropdown/Dropdown";
import Button from "../../components/Button/Button";
import {
  CartesianGrid,
  Label,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  ScatterChart,
  Scatter,
  Tooltip,
  TooltipProps 
} from "recharts";
import TopRow from "../../components/TopRow/TopRow";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
import { apiUrl } from "../../config/api";



const PowerSearch: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const [map, setMap] = React.useState<any>(null);
  const [mapCenter, setMapCenter] = React.useState<any>({
    lat: -29.857233,
    lng: 31.021517,
  });
  const { isLoaded } = useJsApiLoader({
    // id: 'google-map-script',
    googleMapsApiKey: String(process.env.REACT_APP_GOOGLE_MAPS_API_KEY),
    version: "3.64", // still has Heatmap Layer, but will be decommissioned again in August
    libraries: ["visualization"],
  });

  const [startDateOpen, setStartDateOpen] = React.useState(false);
  const [endDateOpen, setEndDateOpen] = React.useState(false);
  const [area, setArea] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [areas, setAreas] = React.useState<any[]>([]);
  const [statuses, setStatuses] = React.useState<any[]>([]);
  const [vehicleData, setVehicleData] = React.useState<any[]>([]);
  const [investigationData, setInvestigationData] = React.useState<any[]>([]);
  const [dayTimeInvestigationData, setdayTimeInvestigationData] = React.useState<
    any[]
  >([]);
  const [dayTimeDeviceInvestigationData, setdayTimeDeviceInvestigationData] = React.useState<
    any[]
  >([]);
  const [heatmapInvestigationData, setheatmapInvestigationData] = React.useState<
    any[]
  >([]);


  const [searchVal, setSearchVal] = React.useState("");
  const [resetClicked, setResetClicked] = React.useState(false);
  const [viewingVehicle, setViewingVehicle] = React.useState(false);
  const [filterOpen, setFilterOpen] = React.useState(false);
  const [dealCode, setDealCode] = React.useState("");
  const [images, setImages] = React.useState<any[]>([]);
  const [viewProofOfLife, setViewProofOfLife] = React.useState(false);

  const [assignIcep, setAssignIcep] = React.useState(false);
  const [roles, setRoles] = React.useState<any[]>(
    JSON.parse(localStorage.getItem("roles") || "[]")
  );
  const [rolesOpen, setRolesOpen] = React.useState(false);

  const vehicleRef = React.useRef<HTMLDivElement>(null);

  const DAYS_ORDER = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  const CustomXAxisTick = ({ x, y, payload }: any) => {
    return (
      <text x={x} y={y + 10} textAnchor="middle">
        {payload.value}
      </text>
    );
  };

  const getRandomColor = () => {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r}, ${g}, ${b})`;
    };

  // Custom Tooltip Component
// const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>)  => {
//   if (active && payload && payload.length) {
//     return (
//       <div className="custom-tooltip">
//         <p className="label">{`${label} : ${payload[0].value}`}</p>
//         <div>
//           {payload.map((pld) => (
//             <div style={{ display: "inline-block", padding: 10 }}>
//               <div style={{ color: pld.color }}>{pld.value}</div>
//               <div style={{ color: "gray" }}>{pld.dataKey} drivers</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   return null;
// };

  function getVehicleData() {
    setLoading(true);
    axios
      .post(
        apiUrl("/v1/cbva/power-search"),
        {
          authentication: {
            token: localStorage.getItem("token"),
            refresh: localStorage.getItem("refreshToken"),
          },
          filters: {
            startdate:
              startDate !== null
                ? String(format(startDate, "yyy-MM-dd")) + " 00:00:00"
                : null,
            enddate:
              endDate !== null
                ? String(format(endDate, "yyy-MM-dd")) + " 00:00:00"
                : null,
            vehiclelicence: searchVal !== "" ? searchVal : null
          },
        },
        {
          headers: {
            Authorization:
              "Basic " +
              base64.encode("cbva: 1e72ecb1-c0cd-4b4b-aeb7-32257997f549"),
          },
        }
      )
      .then((response) => {
        setInvestigationData(response.data.data.summary_area_data);
        console.log(response.data.data.time_day_device_data)
        setdayTimeInvestigationData(response.data.data.day_time_data)
        setdayTimeDeviceInvestigationData(response.data.data.time_day_device_data)
        setheatmapInvestigationData(response.data.data.heatmap_image)

        setViewingVehicle(true);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }


  const onLoad = (heatmap: { set: (arg0: string, arg1: string[]) => void }) => {
    // Access to the heatmap object

    heatmap.set("map", map);

    // You can customize the gradient here
    // heatmap.set('gradient', gradient)
  };

  const onUnmount = (heatmap: { set: (arg0: string, arg1: null) => void }) => {
    heatmap.set("data", null);
  };




  if (!isLoaded) {
    return <Loading />;
  }

  return (
    <div className="background">
      {loading && <Loading />}
      
      
      <div id="map" className="map-container">
        
      </div>

      <TopRow />

      
        <div id="content" className="content">
          <div style={{ marginTop: "67px" }} className="second-row">
            <div className="filter-container-investigation">
              <div className="filters">
                <div style={{ backgroundColor: "transparent" }}>
                  <DatePicker
                    onInputClick={() => setStartDateOpen(!startDateOpen)}
                    onClickOutside={() => setStartDateOpen(false)}
                    value={
                      startDate !== null
                        ? String(format(startDate, "dd.MM.yyy"))
                        : ""
                    }
                    id="start-date-picker"
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setStartDateOpen(false);
                    }}
                    open={startDateOpen}
                    customInput={
                      <Dropdown
                        id="start-date"
                        containerStyle={{}}
                        label="Start Date"
                        hasArrow={true}
                        isClearable={true}
                        onClear={() => {
                          setStartDate(null);
                          setStartDateOpen(false);
                        }}
                        arrowImg={arrowDown}
                        // value={startDate !== null ? String(format(startDate, 'dd.MM.yyy')) : ''}
                        handleClick={() => {
                          setStartDateOpen(!startDateOpen);
                        }}
                      />
                    }
                  />
                </div>
                <div style={{ backgroundColor: "transparent" }}>
                  <DatePicker
                    onClickOutside={() => setEndDateOpen(false)}
                    value={
                      endDate !== null
                        ? String(format(endDate, "dd.MM.yyy"))
                        : ""
                    }
                    id="end-date-picker"
                    selected={endDate}
                    onChange={(date) => {
                      setEndDate(date);
                      setEndDateOpen(false);
                    }}
                    open={endDateOpen}
                    customInput={
                      <Dropdown
                        isClearable={true}
                        onClear={() => {
                          setEndDate(null);
                          setEndDateOpen(false);
                        }}
                        id="end-date"
                        label="End Date"
                        hasArrow={true}
                        arrowImg={arrowDown}
                        value={
                          endDate !== null
                            ? String(format(endDate, "dd.MM.yyy"))
                            : ""
                        }
                        handleClick={() => {
                          setEndDateOpen(!endDateOpen);
                        }}
                      />
                    }
                  />
                </div>
                <div
                  className="area-status-container"
                  ref={vehicleRef}
                  style={{ backgroundColor: "transparent" }}
                >
                  <Input
                    isSearch={true}
                    style={{ margin: 0 }}
                    label="Search"
                    id="search-vehicle"
                    name="search"
                    placeholder="Vehicle Search..."
                    value={searchVal}
                    handleChange={(text) => {
                      setSearchVal(text);
                    }}
                    disabled={false}
                    isError={false}
                    errorText=""
                    hasArrow={false}
                  />
                </div>

                
              </div>
              <div className="filter-buttons">
                <Button
                  style={{ marginRight: "10px" }}
                  className="filter-button filter-button-blue"
                  id="filter-button"
                  label="Filter"
                  handleClick={() => {
                    getVehicleData();
                  }}
                />
                {/* <Button
                  className="filter-button filter-button-white"
                  id="reset-button"
                  label="Reset"
                  handleClick={async () => {
                    await setStartDate(null);
                    await setEndDate(null);
                    await setArea("");
                    await setStatus("");
                    await setResetClicked(true);
                  }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      {viewingVehicle && (
        <div className="table-container-icep">
            <div className="table-row-top-icep">
              <div className="table-header-icep">Vehicle Overview</div>
            </div>
            <div id="content" className="content">
              <div className="table-container-icep">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginLeft: "30px",
                  }}
                >
                  <Table
                      order={[[2, "asc"]]}
                      paging={false}
                      tableName="transactions"
                      className="transactions-table"
                      search={searchVal}
                      data={investigationData}
                      columns={[
                        {
                          title: "Area",
                          data: "area",
                        },
                        {
                          title: "Count",
                          data: "count",
                        },
                        {
                          title: "Last Seen",
                          data: "last_seen",
                          render: (data: any) => {
                            return String(format(new Date(data), "yyy-MM-dd hh:mm:ss"));
                          },
                        },
                      ]}
                    />
                </div>
              </div>
              <div className="user-investigation-container" id="user-investigation">
                <div className="table-header">Frequency by time of day and day of week</div>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
                  >
                    <XAxis
                      allowDuplicatedCategory={false}
                      interval={2}
                      dataKey="tod"
                      axisLine={false}
                      tickLine={false}
                      style={{
                        textAnchor: "middle",
                        fontFamily: "Poppins",
                        fontSize: "10px",
                        fontWeight: "400",
                        color: "#94A3B8",
                        lineHeight: "normal",
                        fontStyle: "normal",
                      }}
                    >
                      
                    </XAxis>
                    <YAxis
                      type="number"
                      // tickCount={11}
                      dataKey="value"
                      axisLine={false}
                      tickLine={false}
                      style={{
                        textAnchor: "middle",
                        fontFamily: "Poppins",
                        fontSize: "10px",
                        fontWeight: "400",
                        color: "#94A3B8",
                        lineHeight: "normal",
                        fontStyle: "normal",
                      }}
                    >
                      
                    </YAxis>
                    <CartesianGrid strokeDasharray="0" horizontal={false} />
                    <Legend
                      verticalAlign="top"
                      iconType="circle"
                      iconSize={8}
                      formatter={(value, entry, index) => {
                        return (
                          <span
                            style={{
                              color: "#94A3B8",
                              fontFamily: "Poppins",
                              fontSize: "10px",
                              fontWeight: "400",
                              lineHeight: "normal",
                              fontStyle: "normal",
                            }}
                          >
                            {value.substring(0, 3)}
                          </span>
                        );
                      }}
                    />
                    {dayTimeInvestigationData.map((series) => (
                      <Line
                        dot={false}
                        dataKey="value"
                        data={series.data}
                        name={series.name}
                        key={series.name}
                        stroke={series.color}
                      />
                    ))}
                  </LineChart>
                </ResponsiveContainer>
              </div>
              <div className="user-investigation-container" id="user-investigation">
                <div className="table-header">Frequency by time of day and day of week and device ID</div>
                <ResponsiveContainer width="100%" height="100%">
                  <ScatterChart
                    width={900}
                    height={500}
                    margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
                  >
                    <CartesianGrid />
                    <XAxis
                      type="category"
                      dataKey="x"
                      name="Day"
                      ticks={DAYS_ORDER}
                      tick={<CustomXAxisTick />}
                    />
                    <YAxis
                      type="number"
                      dataKey="y"
                      name="Time of Day"
                      domain={[0, 24]}
                      tickFormatter={(tick) => `${tick.toFixed(0)}:00`}
                      label={{ value: 'Hour of Day', angle: -90, position: 'insideLeft' }}
                    />
                    {/* <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} /> */}
                    <Legend />

                    {/* Invisible scatter to force rendering all days */}
                    <Scatter
                      data={DAYS_ORDER.map((day) => ({ x: day, y: 0 }))}
                      fill="transparent"
                      name="Padding"
                    />

                    {/* Actual device scatter plots */}
                    {dayTimeDeviceInvestigationData.map((device, index) => (
                      <Scatter
                        key={index}
                        name={device.deviceid}
                        data={device.data}
                        fill={getRandomColor()}
                      />
                    ))}
                  </ScatterChart>


                </ResponsiveContainer>
              </div>
              <div className="heatmap-image-container">
                <div className="table-header">Heatmap</div>
                  <img src={`data:image/jpeg;base64,${heatmapInvestigationData}`} style={{width: 600}} alt="heatmap" />
              </div>
            </div>
        </div>
                
      )}
    </div>
  
  );
};

export default PowerSearch;
